import { render, staticRenderFns } from "./OnboardingStep3.vue?vue&type=template&id=49135f42&scoped=true&lang=pug"
import script from "./OnboardingStep3.vue?vue&type=script&lang=js"
export * from "./OnboardingStep3.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStep3.vue?vue&type=style&index=0&id=49135f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49135f42",
  null
  
)

export default component.exports